<template>
  <div class="hb-out-open" @click.stop="test" :class="{'no-style': noStyle}">
    <!-- <div @click="openHeyboxApp" class="inner-text">{{ text }}</div> -->
    <!-- {{ text }} -->
    <!-- v-if="canUseDeepLink" -->
    <wx-open-launch-app
      id="hb-launch-btn"
      class="hb-out-open-button"
      :appid="appid"
      :extinfo="extinfo"
      @launch="handleLaunch"
      @error="handleError"
    >
      <script type="text/wxtag-template">
        <style>
          .btn {
            width: 9999px;
            height: 9999px;
            background-color: red;
            opacity: 0;
          }
        </style>
        <button class="btn">button</button>
      </script>
    </wx-open-launch-app>
  </div>
  
</template>

<script>
import { wxShare, executeProtocolOutApp } from '_lib/utils'
export default {
  props: {
    protocol: {
      type: String,
      default: 'heybox://{"protocol_type": "login"}'
    },
    pageIdentifier: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: '在小黑盒查看'
    },
    noStyle: {
      type: Boolean,
      default: false
    },
    weixindata: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      appid: 'wxe8989eb8b38b5c4d',
      canUseDeepLink: false,
    }
  },
  watch: {
    // weixindata: {
    //   handler (v) {
    //     if (v && Object.keys(v).length > 0) {
    //       // wxShare(v, null, true)
    //     }
    //   },
    //   deep: true,
    //   immediate: true
    // }
  },
  computed: {
    extinfo () {
      return JSON.stringify({
        protocol: this.protocol,
        open_source: 'wechat',
        page_identifier: this.pageIdentifier
      })
    }
  },
  created () {
    // this.judegeCanUseDeepLink()
    // 符合微信最低版本7.0.12，iOS最低版本10.3，Android最低版本5.0，仍然无法使用开放标签时触发事件
    // console.log('WeixinOpenTagsError');
    // document.addEventListener('WeixinOpenTagsError', function (e) {
    //   this.canUseDeepLink = false
    // })
  },
  methods: {
    test() {
      console.log('test');
    },
    openHeyboxApp () {
      executeProtocolOutApp(this.protocol)
    },
    // 点击成功之后执行
    handleLaunch (e) {
      let { extInfo } = e.detail
      this.$emit('launch:success')
    },
    // 跳转失败，跳下载
    handleError (err) {
      // 当前场景不支持跳转，或Android上该应用未安装，或iOS上用户在弹窗上点击确认但该应⽤未安装
      window.location = 'https://api.xiaoheihe.cn/heybox/share'
      this.$emit('launch:error')
    },
    judegeCanUseDeepLink () {
      // 微信版本号大于 7.0.12 开放标签才可进行 唤醒 app 跳转
      const wechatInfo = window.navigator.userAgent.match(
        /MicroMessenger\/([\d\.]+)/i
      )
      if (!wechatInfo) return
      let judgewechat = wechatInfo[1].split(".")
      if (judgewechat[0] >= 7 && judgewechat[1] >= 0 && judgewechat[2] >= 12) {
        this.canUseDeepLink = true
      }
    },
  }
}
</script>

<style lang="less">
.hb-out-open {
  position: absolute;
  cursor: pointer;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 50;
  // &:not(.no-style) {
  //   position: fixed;
  //   left: 0;
  //   right: 0;
  //   bottom: 60px;
  //   width: 100px;
  //   margin: auto;
  //   border-radius: 17px;
  //   background: #14191e;
  //   z-index: 2020;
  //   box-shadow: 0 10px 16px 0 rgba(20, 25, 30 , 14%);
  //   height: 34px;
  //   color: #FFFFFF;
  //   font-size: 12px;
  // }
  // .inner-text {
  //   width: 100%;
  //   height: 100%;
  //   display: flex;
  //   justify-content: center;
  //   align-items: center;
  //   &.no-touch {
  //     pointer-events: none;
  //   }
  // }
  .hb-out-open-button {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    border-radius: inherit;
    overflow: hidden;
  }
}
</style>